/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */
import { MathPlaceholder } from 'semantic-math-editor';
export const debounce = require('lodash.debounce');
export const PLACEHOLDER = new MathPlaceholder();
export const ADD_ROW = 'addRow';
export const REWRITE_ROW = 'rewrite';
export const MAX_DELAY = 10000;
